import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

const useBackspaceNavigation = () => {
    const navigate = useNavigate();

    useEffect(() => {
        const handleKeyDown = (event) => {
            // Check if backspace is pressed and we're not in an input field
            if (event.key === 'Backspace') {
                const activeElement = document.activeElement;
                const isInputField = activeElement && (
                    activeElement.tagName === 'INPUT' ||
                    activeElement.tagName === 'TEXTAREA' ||
                    activeElement.isContentEditable
                );

                // Only navigate back if we're not typing in an input field
                if (!isInputField) {
                    event.preventDefault();
                    navigate(-1); // Go back in history
                }
            }
        };

        // Add event listener to document
        document.addEventListener('keydown', handleKeyDown);

        // Cleanup function
        return () => {
            document.removeEventListener('keydown', handleKeyDown);
        };
    }, [navigate]);
};

export default useBackspaceNavigation;
